import messages from '@/languages'
import {Boot} from 'src/project'
import VueI18n, {I18nOptions} from 'vue-i18n'

export const i18nDefaultOptions: I18nOptions = {
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  locale: 'ko-KR',
  fallbackLocale: 'en-US',
  messages,
}

const boot: Boot = ({Vue, app}) => {
  Vue.use(VueI18n)
  app.i18n = new VueI18n(i18nDefaultOptions)
}

export default boot
